export const shouldPreserveCopyTemplateState = ({
  isCopyMode,
  previousTemplate,
  incomingTemplate
}) => {
  return (
    Boolean(isCopyMode) &&
    Boolean(previousTemplate?._isCopyTemplate) &&
    !Boolean(incomingTemplate?._isCopyTemplate)
  );
};
